import { PAGE_PATHS } from "./config.ts";
import { ShowPets } from "./ShowPets.tsx";

export default function pet404() {
  return (
    <>
      <div className="flex items-center flex-col">
        <h2 className="text-2xl md:text-3xl text-[#ef3825] mr-2">
          Not Available
        </h2>
        <p>Sorry, this pet is no longer available for adoption.</p>
        <div className="mb-8"></div>
      </div>

      <section className="pet-adoption px-[5%] py-12">
        <h3 className="w-100% text-center text-xl font-bold my-6">
          DOGS{" "}
          <a
            href={PAGE_PATHS.ALL_DOGS}
            className="text-base text-[#ef3825] hover:text-[#79c4b7]"
          >
            (See All)
          </a>
        </h3>

        <ShowPets
          petType="dog"
          display={"carousel"}
          title={"Dogs"}
          allPetsLink={PAGE_PATHS.ALL_DOGS}
        />

        <div className="mb-16" />

        <h3 className="w-100% text-center text-xl font-bold my-6">
          CATS{" "}
          <a
            href={PAGE_PATHS.ALL_CATS}
            className="text-base text-[#ef3825] hover:text-[#79c4b7]"
          >
            (See All)
          </a>
        </h3>

        <ShowPets
          petType="cat"
          display={"carousel"}
          title={"Cats"}
          allPetsLink={PAGE_PATHS.ALL_CATS}
        />

        <div className="mb-16" />

        <h3 className="w-100% text-center text-xl font-bold my-6">
          CRITTERS{" "}
          <a
            href={PAGE_PATHS.ALL_CRITTERS}
            className="text-base text-[#ef3825] hover:text-[#79c4b7]"
          >
            (See All)
          </a>
        </h3>

        <ShowPets
          petType="small"
          display={"carousel"}
          title={"Critters"}
          allPetsLink={PAGE_PATHS.ALL_CRITTERS}
        />
      </section>
    </>
  );
}
